(function () {
  function enhanceTypeCarousel() {
    var grid = document.querySelector('main[data-template="index"] .typese-type-grid');

    if (!grid || grid.dataset.typeseCarousel === 'true') return;

    var wrapper = document.createElement('div');
    wrapper.className = 'typese-type-carousel';
    grid.parentNode.insertBefore(wrapper, grid);
    wrapper.appendChild(grid);

    var controls = document.createElement('div');
    controls.className = 'typese-type-controls';

    var previous = document.createElement('button');
    previous.type = 'button';
    previous.setAttribute('aria-label', 'Previous type');
    previous.className = 'typese-type-control';
    previous.textContent = '←';

    var next = document.createElement('button');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next type');
    next.className = 'typese-type-control';
    next.textContent = '→';

    controls.append(previous, next);
    wrapper.appendChild(controls);

    function getStep() {
      var card = grid.querySelector('.typese-type-card');
      if (!card) return grid.clientWidth;

      var styles = window.getComputedStyle(grid);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);
      return card.getBoundingClientRect().width + gap;
    }

    function updateControls() {
      var maxScroll = grid.scrollWidth - grid.clientWidth - 2;
      previous.disabled = grid.scrollLeft <= 2;
      next.disabled = grid.scrollLeft >= maxScroll;
    }

    previous.addEventListener('click', function () {
      grid.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      grid.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls);

    grid.dataset.typeseCarousel = 'true';
    updateControls();
  }

  function enhanceProductList() {
    var productList = document.querySelector('main[data-template="index"] [data-testid="product-list"]');

    if (!productList || productList.dataset.typeseEnhanced === 'true') return;

    var more = document.createElement('div');
    more.className = 'typese-products-more';

    var link = document.createElement('a');
    link.href = '/collections/all';
    link.textContent = 'More';

    more.appendChild(link);
    productList.appendChild(more);
    productList.dataset.typeseEnhanced = 'true';
  }

  function init() {
    enhanceTypeCarousel();
    enhanceProductList();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
